// TODO: test
// import { isServer } from '@tunein/web-utils';
// export default isServer;

export default function isServer() {
  return typeof window === 'undefined';
}
